import { Button, Tooltip, useDisclosure, Box, keyframes, Center, Text, Flex } from '@chakra-ui/react'
import { Share } from '@olagg/ui-kit'
import ShareModal from './ShareModal'
import { Xp } from '@olagg/ui-kit/svg/Xp'
import { XpDots } from '@olagg/ui-kit/svg/XpDots'
import { t } from 'i18next'
import { useTranslation } from 'react-i18next'

export default function ShareButton({
    title,
    description,
    link,
    size = 'default',
    variant = 'outlined',
    border = '2px solid white',
    animate = false,
    shareText = false
}) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { t } = useTranslation();
    const rotate = keyframes`  
        0%  {transform: scale(0) rotate(0deg)}
        23% {transform: scale(0) rotate(0deg)}
        26% {transform: scale(0.8, 0.8) rotate(0deg)}
        30% {transform: scale(0.8, 0.8) rotate(0deg)}
        40% {transform: scale(0.3, 0.3) rotate(0.5turn)}
        50% {transform: scale(0.8, 0.8) rotate(1turn)}
        53% {transform: scale(0.8, 0.8) rotate(1turn)}
        60% {transform: scale(0) rotate(0deg)}
        100% {transform: scale(0) rotate(0deg)}
    `;

    const zoom = keyframes`  
        0%  {transform: scale(0)}
        13% {transform: scale(0)}
        20% {transform: scale(1.3, 1.3)}
        23% {transform: scale(1.15, 1.15)}
        50% {transform: scale(1.15, 1.15)}
        53% {transform: scale(1.3, 1.3)}
        60% {transform: scale(0)}
        100% {transform: scale(0)}
    `;

    const fade = keyframes`  
        0%  {opacity: 1}
        10% {opacity: 1}
        16% {opacity: 0}
        56% {opacity: 0}
        61% {opacity: 1}
        100% {opacity: 1}
    `;

    return (
        <>
            <ShareModal title={title} description={description} link={link} isOpen={isOpen} onClose={onClose} />
            <Tooltip label={shareText ? '' : t('tournaments.card.shareText')}>
                <Box position='relative' onClick={onOpen} cursor='pointer'>
                    {animate && (<>
                        <Center position='absolute' top='0' w='full' h='full' animation={`${rotate} infinite 6s linear`} zIndex='15'>
                            <XpDots color={variant === 'outlinedGradient' ? undefined : 'white'} />
                        </Center>
                        <Center position='absolute' top='0' px='14px' w='full' h='full' animation={`${zoom} infinite 6s linear`} zIndex='10'>
                            <Flex bgColor={variant ? 'purple' : 'white'} h='22px' borderRadius={'50px'}><Xp color={variant ? 'white' : 'purple'} transparentBackground /></Flex>
                        </Center>
                    </>)}
                    <Button
                        variant={variant}
                        border={border}
                        h={size == 'small' ? '30px' : '44px'}
                        py='0'
                        px={size == 'small' ? shareText ? '12px' : '0' : '10px'}
                        w={size == 'small' ? shareText ? 'auto' : '22px' : 'auto'}
                        ml={size == 'small' ? '5px' : 0}
                        sx={{ 'span': { marginInlineEnd: 0 } }}
                        leftIcon={
                            <Box animation={animate && `${fade} infinite 6s linear`}>
                                <Flex direction='row'>
                                    <Share color={variant === 'outlinedGradient' ? 'filledGradient' : 'white'} style={{ width: size == 'small' ? '15px' : '22px', marginTop: '2px' }} />
                                </Flex>
                            </Box>
                        }
                    >
                        {shareText && <Text ml='6px' fontSize='16px' fontWeight={'600'}>{t('shareText')}</Text>}
                    </Button>
                </Box>
            </Tooltip>
        </>
    )
}
